
import StatusErrorBanner from '@justeat/f-status-banner';
import '@justeat/f-status-banner/dist/f-status-banner.css';

export default {
    components: {
        StatusErrorBanner
    },

    props: {
        error: {
            type: Object,
            required: true
        }
    },

    mounted () {
        this.$log.error(
            `${this.error.message} - with status code - ${this.error.statusCode}`,
            null,
            'core-team',
            {
                route: this.$route,
                responseCode: this.error.statusCode
            }
        );

        this.$gtm.pushPageData({
            pageName: 'error',
            httpStatusCode: '404'
        });
    }
};
